import { useState } from 'react'
import toast from 'react-hot-toast'
import { DetailObject } from '../../interfaces/intakes.reports'
import { useEditNewItem } from '../../api/useEditNewItem'
import { DetailName } from '../../interfaces/interfaces'
import { ModalBtn } from '../modals/ModalBtn'
import { useQueryClient } from '@tanstack/react-query'

interface Props {
    closeModal: () => void
    reportId: string
    palletId: string
    detailName: DetailName
    item: DetailObject
}

export const ModalPalletRefName = ({ closeModal, reportId, palletId, detailName, item }: Props) => {

    // const queryClient = useQueryClient()
    const [newValue, setNewValue] = useState(item.value)
    const { mutate, isLoading } = useEditNewItem()
    const queryClient = useQueryClient()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setNewValue(e.target.value as string | number | boolean)
    }

    const sendEditItem = async () => {

        if (item.value === newValue) return closeModal()

        mutate({
            reportId,
            palletId,
            detailName,
            name: item.name,
            value: newValue,
        }, {
            onSuccess: async( ) => { 
                await queryClient.invalidateQueries(['reportTemp', reportId])
                closeModal()
            },
            onError: (err) => { console.log(err); toast.error("Something went wrong") }
        })
    };


    return (
        <div className="modal">

            <div className="modal__card">

                {
                    <div className="modal__content">

                        {/* {
                            confirmation &&
                            <ModalConfirmation
                                buttonName='Delete'
                                msg={`Are you sure you want to delete ${item.label}?`}
                                closeConfirmation={() => setConfirmation(false)}
                                isLoading={isDeleting}
                                action={() => deleteItem()}
                            />
                        } */}

                        <div className='flex-space-between mb-2'>
                            <label className="modal-label">{item.label}</label>
                            {/* <button onClick={() => setConfirmation(true)} className='flex-center remove-btn mb-05'>
                                <img src='../../assets/img/edit-remove.svg' alt='remove-icon' width={18} />
                            </button> */}
                        </div>


                            <input
                                type="text"
                                value={newValue as string}
                                name={item.name}
                                onChange={handleChange}
                                maxLength={30}
                            />
                      

                     

                        <ModalBtn
                            closeModal={() => closeModal()}
                            action={sendEditItem}
                            isLoading={isLoading}
                        />

                    </div>
                }
            </div>
        </div>
    )
}